import {Component} from '@angular/core';
import {AuthenticationService} from './user/authentication.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  title = 'pwa-angular';

  constructor(public authenticationService: AuthenticationService) {}

}
